module.exports = __webpack_public_path__ + "img/110082.76fd7fcf.png";